import { Modal } from 'antd'

import styles from './confirmDeleteTask.module.css'

export const getDeleteTaskTypeLabel = (type) =>
    String(type || 'Task').trim().toLowerCase() || 'task'

export const getDeleteTaskMenuLabel = (type) =>
    `Delete ${getDeleteTaskTypeLabel(type)}`

/**
 * Shared Ant Design confirm dialog for deleting a task.
 * Used by board/list context menus and task detail view.
 *
 * `isTimelog` blocks the delete: time has been logged against the task, so the
 * dialog explains why and disables the Delete button. Only the Development
 * module tracks timelogs, so Support callers leave this false.
 *
 * @param {{ onConfirm?: () => void|Promise<void>, type?: string, isTimelog?: boolean }} [options]
 */
export const confirmDeleteTask = ({
    onConfirm,
    type,
    isTimelog = false,
} = {}) => {
    const itemLabel = getDeleteTaskTypeLabel(type)

    Modal.confirm({
        title: `Delete this ${itemLabel}?`,
        content: isTimelog
            ? `This ${itemLabel} cannot be deleted because time has already been logged against it.`
            : `This ${itemLabel} will be removed from the project. This cannot be undone.`,
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        centered: true,
        maskClosable: true,
        okButtonProps: {
            danger: true,
            type: 'primary',
            className: styles.deleteBtn,
            disabled: isTimelog,
        },
        cancelButtonProps: {
            className: styles.cancelBtn,
        },
        onOk: async () => {
            // Guard as well as disable, so the delete can't be reached by a
            // keyboard confirm even if the button state is bypassed.
            if (isTimelog) return
            if (typeof onConfirm === 'function') {
                await onConfirm()
            }
        },
    })
}

export default confirmDeleteTask
